import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class ContractorCategories extends AbstractController {
    protected controllerName = 'ContractorCategories';
}
